export var Size;
(function (Size) {
    Size["Small"] = "SMALL";
    Size["Medium"] = "MEDIUM";
    Size["Large"] = "LARGE";
    Size["Default"] = "DEFAULT";
})(Size || (Size = {}));
//# sourceMappingURL=design-system.js.map